<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="position.postID > 0 ? '编辑':'新建'"
        class="customer-edit"
        width="500px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="position"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <el-form-item label="职位编号">
          <el-input v-model="position.postNO" disabled placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="职位名称" prop="PostName">
          <el-input v-model="position.postName" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="上级职位" prop="ParentName">
          <div style="display: flex;flex-direction: row;">
            <el-select v-model="position.parentName" clearable placeholder="请选择">
              <el-option
                  v-for="item in PositionList"
                  :key="item.postID"
                  :label="item.postName"
                  :value="item.postName"
                  @click.native="selectParentName(item.postID)"/>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="position.note" type="textarea" placeholder="请输入"/>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import constants from "../../../util/constants";

  export default {
    name:"PositionEdit",
    components: {},
    data() {
      return {
        constants,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        PositionList:[],
        position: {
          postID: "",
          postNO: "",
          postName: "",
          parentName: "",
          note: "",
          parentID: "",
          isDeleted: "",
        },
        ruleValidate: {
          postName: {required: true, message: "不能为空",trigger: "blur"},
          parentName: {required: true, message: "不能为空",trigger: "blur"},
        },
      };
    },
    methods: {
      selectParentName(id) {
        console.log(id);
        this.position.parentID = id;
      },
      open(row) {
        console.log(row);
        this.position.postID = row.postID;
        this.dialogVisible = true;
        this.getPositionList();
        if(this.position.postID>0) {
          this.getData();
        }else {
          this.getNode();
        }
      },
      getPositionList() {
        this.$http
          .get("basic", "posts/list")
          .then(resp => {
            this.PositionList = resp;
          });
      },
      getData() {
        this.$http
          .get("basic", `posts/${this.position.postID}`)
          .then(resp => {
            this.position = resp;
          });
      },
      getNode() {
        this.$http
          .get("basic", "posts/selectNo")
          .then(resp => {
            this.position.postNO = resp;
          });
      },

      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            if(this.position.postID>0) {
              this.$http
                .put("basic", "posts", this.position)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }else {
              this.$http
                .post("basic", "posts", this.position)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
